import { Stats } from "../../../screens/reader/components/shared/Stats";
import { User } from "../../../types";
import { useTranslation } from "react-i18next";
import { formatLargeNumber } from "../../../utils/formatLargeNumber";

export interface UserVitalsProps {
  user: User;
}

export function UserVitals({ user }: UserVitalsProps) {
  const { t } = useTranslation();

  return (
    <Stats
      expandable
      stats={[
        {
          text: t("components.slideInMenu.userProfile.completions"),
          value: formatLargeNumber(user.total_releases_completed || 0, {
            decimalPlaces: 1,
          }),
        },
        {
          text: t("components.slideInMenu.userProfile.readPages"),
          value: formatLargeNumber(user.total_pages_read || 0, {
            decimalPlaces: 1,
          }),
        },
        {
          text: t("components.slideInMenu.userProfile.library"),
          value: formatLargeNumber(user.favorites_count || 0, {
            decimalPlaces: 1,
          }),
        },
        {
          text: t("components.slideInMenu.userProfile.following"),
          value: formatLargeNumber(user.following_count || 0, {
            decimalPlaces: 1,
          }),
        },
      ]}
    />
  );
}
